type DataItem = {
    key: number;
    resource_type: string;
    region: string;
    service_line: string;
    function: string;
    career_level: string;
    cost_per_hour: number;
    target_client_margin: number;
    proposed_price_per_hour: number;
    targetPriceHr: number;
    clientMarginProposed: number;
    varianceTargetMargin: number;
    resource_requirement_id?: string;
};

type DistinctValues = {
    resourceTypes: string[];
    selectRegions: string[];
    serviceLineCapabilities: string[];
    functions: string[];
    selectLevels: string[];
};

// Define string fields that need validation
type StringFields = 'resource_type' | 'region' | 'service_line' | 'function' | 'career_level';

// Define field validation hierarchy
const validationSteps: Array<{
    field: StringFields,
    validValues: keyof DistinctValues
}> = [
    { field: 'resource_type', validValues: 'resourceTypes' },
    { field: 'region', validValues: 'selectRegions' },
    { field: 'service_line', validValues: 'serviceLineCapabilities' },
    { field: 'function', validValues: 'functions' },
    { field: 'career_level', validValues: 'selectLevels' }
];

// Default empty numeric values
const defaultNumericValues = {
    cost_per_hour: 0,
    target_client_margin: 0,
    proposed_price_per_hour: 0,
    targetPriceHr: 0,
    clientMarginProposed: 0,
    varianceTargetMargin: 0
};

const cleanResourceRequestList = (data: DataItem[], distinctValues: DistinctValues): DataItem[] => {
    return data.map(item => {
        const newItem = { ...item };
        
        // Iterate through validation steps in order
        for (let i = 0; i < validationSteps.length; i++) {
            const { field, validValues } = validationSteps[i];
            
            // Check if the current field's value is valid
            if (!distinctValues[validValues].includes(newItem[field])) {
                // Clear this field and all subsequent fields
                for (let j = i; j < validationSteps.length; j++) {
                    const fieldToClear = validationSteps[j].field;
                    newItem[fieldToClear] = "";
                }
                
                // Reset all numeric values
                Object.assign(newItem, defaultNumericValues);
                
                break; // Exit the validation loop once we find a failure
            }
        }        
        // All validations passed, return the original item
        return newItem;
    });
};

export default cleanResourceRequestList;
